
import { mapState, mapGetters } from 'vuex';
import ThumbnailShape from '@/enums/ThumbnailShape';
export default {
  name: 'AppProductInfoSectionV2',
  props: {
    review: {
      type: Object,
      required: true
    },
    showArrow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('widget', ['widget']),
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapGetters('widget', ['device']),
    starStyleProps() {
      return {
        '--star-color': this.reviewSettings.star_color
      };
    },
    reviewsCountLabel() {
      return this.$t('reviews_count', {
        count: this.review.product_meta_reviews_count
      });
    },
    scoreText() {
      return this.review.product_meta_score.toFixed(1);
    },
    productImageFrame() {
      return this.widget.product_thumbnail_shape === ThumbnailShape.SQUARE
        ? 'rounded'
        : 'circle';
    }
  }
};
